// Fades sections in as they scroll into view. Respects reduced motion (CSS turns the transition off).

const observer = 'IntersectionObserver' in window
  ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' })
  : null;

export function watchReveals(root = document) {
  root.querySelectorAll('.reveal:not(.is-in)').forEach((el) => (observer ? observer.observe(el) : el.classList.add('is-in')));
}

watchReveals();
document.addEventListener('shopify:section:load', (event) => watchReveals(event.target));
